import React from 'react'
import { ContactTemplate } from './../templates/_index'

export default function ContactPage(props) {
  return (
    <ContactTemplate {...props} />
  )
}
